import React from 'react'
import $ from 'jquery'

import Sectiontitle from './sectionTitle'
import Button from './button'

import '../sass/partials/banner.scss'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faMobileAlt } from '@fortawesome/fontawesome-free-solid'

class Banner extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            height: '600px',
            generalHeight: '200px'
        }
    }

    componentDidMount() {
        this.state = {
            height: `${window.outerHeight}px`
        }

        window.addEventListener('resize', () => {
            this.state.height = `${window.outerHeight}px`;
        });

        setTimeout(() => {
            $('.banner--main__title').addClass('is-show');
        }, 100);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', null);
    }

    bannerStyle() {
        if (this.props.type === 'homepage') {
            return (
                <section className={`banner banner--main banner__${this.props.type}`} style={{ height: this.state.height}}>
                    <div className="container">
                        <div className="banner--main__title">
                            <Sectiontitle title="Oxford Based" color="white" />
                            <h2>Looking for Childminder?</h2>
                            <h3>Welcome to Quality Assured  Professional Childcare</h3>
                            <h4 className="phone"><FontAwesomeIcon icon={faMobileAlt} /> 07863 337472</h4>
                            {/* <Button text="Opens: 9 AM - 5 PM" /> */}
                        </div>
                    </div>
                </section>
            );
        } else {
            return (
                <section className={`banner banner--general banner__${this.props.type}`} style={{ height: this.state.generalHeight}}>
                    <div className="container">
                        {this.props.title &&
                            <h1>{this.props.title}</h1>
                        }
                    </div>
                </section>
            );
        }
    }

    render() {
        return ( 
            <div>
                {this.bannerStyle()}
            </div>
        );
    }
}

export default Banner


// WEBPACK FOOTER //
// ./src/components/banner.js